// In dev mode, react will output a lot of errors
// a lot of them are not interesting, let's filter them out

export const UnwantedErrors = [
  'Each child in a list should have a unique', // unique key warning
  'provided to the classes prop is not implemented in Component', // withStyles bug in MUI
  'theme.spacing.unit usage has been deprecated.', // need a ticket to replace `theme.spacing.unit * y` with `theme.spacing(y)`.
  'when also providing the `getContentAnchorEl` prop to the popover component.',
  'Cannot update during an existing state transition',
  'of `Grid` must be used on',
  'ForwardRef(Popper)', // error from the library
  // IMPORTANT TODO: BELOW ARE MUI/RECHARTS DEPRECATION ERRORS THAT SHOULD BE FIXED WHEN WE UPGRADE
  'The prop `disableBackdropClick` of `ForwardRef(Dialog)` is deprecated.', // mui
  'prop type `points[0].value` is invalid', // recharts
];

const ErrsToEnrich = [
  [
    '<tr> cannot appear as a child of <table>',
    'Add <TableBody>...</TableBody> around your table rows after the </TableHead>',
  ],
];

export const ConsoleErrorForDevMode = (backupConsoleError: any) => {
  return (message?: any, ...optionalParams: any[]): void => {
    if (message === undefined) {
      return;
    }

    // filter out err
    if (typeof message === 'string') {
      for (const unwantedErr of UnwantedErrors) {
        if (message.includes(unwantedErr)) {
          return;
        }
      }

      // enrich err
      for (const toEnrichPair of ErrsToEnrich) {
        if (message.includes(toEnrichPair[0])) {
          message = '[HELPER:] ' + toEnrichPair[1] + '\n\n' + message;
          break;
        }
      }
    }

    backupConsoleError(message, ...optionalParams);
  };
};
